module.exports = __webpack_public_path__ + "img/kyobo_main.1f4db32c.png";